import {
  getRecordingStatus,
} from '../../redux/meeting/actions';

export const mapStateToProps = state => ({
  isPasswordAccessEnabled: state.meeting.isPasswordAccessEnabled,
  isModerator: state.meeting.isModerator,
  isPasswordVerified: state.meeting.isPasswordVerified,
  meetingId: state.meeting.meetingId,
});

export const mapDispatchToProps = (dispatch) => ({
  getRecordingStatus: (meetingId) => {
    dispatch(getRecordingStatus(meetingId));
  },
});
